// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function HistoricalDataImportRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['HistoricalDataImport']

   if (state.product_list['historicalDataImport']?.NotInPricebook) {
      return <> </>
   }

   if (
      permissions.includes(state.user_role) ||
      state.productHistoricalDataImport
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['historicalDataImport']['ProductName']}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.productHistoricalDataImport}
                  onChange={() =>
                     state.setProductHistoricalDataImport((prev) => !prev)
                  }
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.HistoricalDataImportCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
